import { UploadOutlined } from "@ant-design/icons"
import { Alert, Button, Card, DatePicker, Flex, Select, Skeleton, Table, Upload } from "antd"
import dayjs from "dayjs"
import { useETLs } from "../../../hooks/templates/useETLs"
import { spaces } from "../../../utils/styles"
import { LoaderFullScreen } from "../../atoms/animations/Loader"

export const ETLs = () => {
  const { datasets, dataset, setDataset, formatAccept, upload, date, setDate, isLoading, uploadHistory, forceAddeparReprocessing } = useETLs()

  const columns = [
    {
      title: "Dataset",
      dataIndex: "name",
      key: "name",
      width: 300,
      align: "center",
    },
    {
      title: "Reference Date",
      dataIndex: "date",
      key: "date",
      width: 200,
      align: "center",
    },
  ]

  if (isLoading) return <LoaderFullScreen showRandomFacts />

  return (
    <Flex style={{ gap: spaces.space2, padding: spaces.space2, alignItems: "center" }} vertical>
      <Card title="Upload new dataset">
        <Flex style={{ gap: spaces.space2, alignItems: "center" }} vertical>
          <Select style={{ width: 550 }} value={dataset} onChange={(value) => setDataset(value)} placeholder="Select dataset">
            {datasets.map((dataset) => (
              <Select.Option key={dataset.value} value={dataset.value}>
                {dataset.label}
              </Select.Option>
            ))}
          </Select>
          {dataset && (
            <Alert
              type="info"
              showIcon
              message={
                <span
                  dangerouslySetInnerHTML={{
                    __html: `Don't you know how to extract the dataset? ${datasets.find((d) => d.value === dataset)?.howToGet || "So we have a problem, Houston! No instructions available for this dataset."}`,
                  }}
                />
              }
              style={{ maxWidth: 550 }}
            />
          )}
          <Flex gap={spaces.space1}>
            <DatePicker
              placeholder="Reference date"
              style={{ width: 200 }}
              value={date}
              onChange={(date) => setDate(date)}
              disabledDate={(current) => current.isAfter(dayjs())}
            />
            <Upload accept={formatAccept} showUploadList={false} beforeUpload={upload}>
              <Button type="primary" icon={<UploadOutlined />} style={{ width: 350 - spaces.space1 }} disabled={!dataset || !date}>
                Upload file
              </Button>
            </Upload>
          </Flex>
        </Flex>
      </Card>
      <Card title="Other actions" style={{ width: 600 }}>
        <Flex style={{ justifyItems: "center", gap: spaces.space2 }} vertical>
          <Button type="primary" onClick={forceAddeparReprocessing}>
            Force Addepar Reprocessing
          </Button>
        </Flex>
      </Card>
      <h2>Upload History</h2>
      <Skeleton loading={!uploadHistory.length} paragraph={{ rows: uploadHistory.length || 3 }} style={{ width: 600 }} active>
        <Table columns={columns} dataSource={uploadHistory} rowKey={(record) => record.name + record.date} style={{ width: 600 }} size="small" />
      </Skeleton>
    </Flex>
  )
}
